import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="6" fill="none" {...props}><path fill="currentColor" d="M0 6h20V.911c0-.923-1.795-1.345-2.906-.296C13.145 4.341 6.266 6 0 6z" /></svg>;